<template>
<div>
    <div :class="'block-title' + (schema.required?' block-title--required':'')">
      {{ schema.label }}
      <div class="block-desc">{{schema.desc}}</div>
    </div>
    
  <div class="form-status status-green" v-if="schema.working.status =='normal'">正常</div>
  <div class="form-status status-red" v-else-if="schema.working.status =='abnormal'">异常</div>
  <div class="form-status status-orange" v-else>无</div>

  <div class="status-tips" :style="'font-size:'+ schema.tips.fontSize +'px;'">
    <span v-if="showOther">{{ schema.working.other }}</span>
    <span v-else>{{ schema.working.label }}</span>
  </div>
  <!-- <van-cell-group>
    <van-cell title="切换状态" icon="exchange" @click="showSelectPicker = true" is-link/>
  </van-cell-group> -->

  <van-field 
    readonly 
    clickable
    :name="schema.name + '_' +schema.uniqid"
    label="切换状态"
    left-icon="exchange"
    right-icon="arrow"
    value=""
    :placeholder="schema.placeholder" 
    :required="schema.required === true" 
    :rules="[{ required: schema.required === true ,message:'请选择'+schema.label}]"
    @click="showSelectPicker = true"
  />
  <van-popup v-model="showSelectPicker" position="bottom">
    <van-picker
      show-toolbar
      swipe-duration="300"
      :title="schema.label"
      :columns="columns"
      @confirm="onSelectConfirm"
      @cancel="showSelectPicker = false"
      @change="onSelectChange"
    />
  </van-popup>

  <van-field v-if="showOther" :name="schema.name + '_' +schema.uniqid +'_other'" v-model="schema.working.other" :placeholder="'请填写'+schema.label" type="text" label="其他"/>
</div>
</template>

<script>
import _ from 'lodash'

const statusOptions = {
  normal:'正常',
  abnormal:'异常',
  none:'无',
}
const unStatusOptions = {
  '正常':'normal',
  '异常':'abnormal',
  '无':'none',
}

export default {
  name: 'formStatus',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  computed:{
    showOther:function(){
      return this.schema.working.label =='其他';
    },
  },
  data:function(){

    let statusArr = _.uniq(this.schema.groups.map((item)=>item.status))
    let labelArr = this.getLabelArr(this.schema.working.status || statusArr[0])
    // console.log('statusArr',statusArr)
    // console.log('labelArr',labelArr)
    return {
      showSelectPicker:false,
      columns: [{ values: statusArr.map((item)=>statusOptions[item]) }, { values:labelArr }],
    }
  },
  methods:{
    getLabelArr:function(status){
      return this.schema.groups.filter((item)=>item.status==status).map((item)=>item.label)
    },
    //确定选项
    onSelectConfirm:function(values, index){
      // console.log('values',values)

      this.schema.working.status = unStatusOptions[values[0]] || 'none'
      this.schema.working.label = values[1] || ''
      if(this.schema.working.label!='其他'){
        this.schema.working.other = '';
      }
      // this.schema.statusIndex = index;
      this.showSelectPicker = false;

      // console.log(this.schema)
    },
    onSelectChange:function(picker, values){
      let status = unStatusOptions[values[0]]
      let labelArr = this.getLabelArr(status)
      picker.setColumnValues(1, labelArr);
    }
  }
}
</script>

<style>
.form-status{
  color: white;
  background-color:#07c160; 
  border-radius: 6px;
  text-align: center;
  padding: 8px 0px;
  width:50%;
  margin:15px auto 10px;
  font-size:20px;
  letter-spacing:5px;
  text-transform:uppercase;
}

.status-red{
  background-color:#ee0a24; 
} 
.status-orange{
  background-color:#ed6a0c; 
} 
.status-green{
  background-color:#07c160; 
} 
.status-blue{
  background-color:#1989fa; 
} 



.status-tips{
  margin-bottom: 10px;
  text-align: center;
  font-size: 30px;
}
</style>